
















import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator';
/* ストア、定数関連 */
import { fileUploadModule } from '../../Uketsuke/store/modules/FileUpload'; // アップロードファイルモジュール
@Component
export default class VariableFileInput extends Vue {
  private validate = require('../../CommonUtils/fixed/Validate'); // Validate
  private privateInvaildMessage: string = '';
  private innerLabel: string = '';
  private rules: any;
  private clearable: boolean = false;
  private counter: string | boolean = false;
  // (ts)親コンポーネントからデータを受け取るpropsは@Propデコレータ
  @Prop({default: false}) private isgroup?: boolean;
  @Prop() private grouplabel?: string;
  @Prop() private label?: string;
  @Prop() private type?: string;
  @Prop() private name!: string;
  @Prop() private value?: string;
  @Prop({default: false}) private readonly?: boolean;
  @Prop({default: false}) private disabled?: boolean;
  @Prop({default: false}) private required?: boolean;
  @Prop() private prefix?: string;
  @Prop() private suffix?: string;
  @Prop() private placeholder?: string;
  @Prop() private hint?: string;
  @Prop() private size?: string;
  @Prop() private maxlength?: string;
  @Prop() private minlength?: string;
  @Prop() private pattern?: string;
  @Prop() private invaildMessage?: string;
  @Prop() private internalId?: string;

  protected selectedFile(e: any) {
    const files = e;
    if (this.internalId === '1') {
        fileUploadModule.setUploadFile1(files[0]);
        fileUploadModule.setCodeNo1(this.value);
    }
    if (this.internalId  === '2') {
        fileUploadModule.setUploadFile2(files[0]);
        fileUploadModule.setCodeNo2(this.value);
    }
    if (this.internalId  === '3') {
      fileUploadModule.setUploadFile3(files[0]);
      fileUploadModule.setCodeNo3(this.value);
    }
    if (this.internalId  === '4') {
      fileUploadModule.setUploadFile4(files[0]);
      fileUploadModule.setCodeNo4(this.value);
    }
    if (this.internalId  === '5') {
      fileUploadModule.setUploadFile5(files[0]);
      fileUploadModule.setCodeNo5(this.value);
    }
    if (this.internalId  === '6') {
      fileUploadModule.setUploadFile6(files[0]);
      fileUploadModule.setCodeNo6(this.value);
    }
    if (this.internalId  === '7') {
      fileUploadModule.setUploadFile7(files[0]);
      fileUploadModule.setCodeNo7(this.value);
    }
    if (this.internalId  === '8') {
      fileUploadModule.setUploadFile8(files[0]);
      fileUploadModule.setCodeNo8(this.value);
    }
    if (this.internalId  === '9') {
      fileUploadModule.setUploadFile9(files[0]);
      fileUploadModule.setCodeNo9(this.value);
    }
    if (this.internalId  === '10') {
      fileUploadModule.setUploadFile10(files[0]);
      fileUploadModule.setCodeNo10(this.value);
    }
    if (this.internalId  === '11') {
      fileUploadModule.setUploadFile11(files[0]);
      fileUploadModule.setCodeNo11(this.value);
    }
    if (this.internalId  === '12') {
      fileUploadModule.setUploadFile12(files[0]);
      fileUploadModule.setCodeNo12(this.value);
    }
    if (this.internalId  === '13') {
      fileUploadModule.setUploadFile13(files[0]);
      fileUploadModule.setCodeNo13(this.value);
    }
    if (this.internalId  === '14') {
      fileUploadModule.setUploadFile14(files[0]);
      fileUploadModule.setCodeNo14(this.value);
    }
    if (this.internalId  === '15') {
      fileUploadModule.setUploadFile15(files[0]);
      fileUploadModule.setCodeNo15(this.value);
    }
    if (this.internalId  === '16') {
      fileUploadModule.setUploadFile16(files[0]);
      fileUploadModule.setCodeNo16(this.value);
    }
    if (this.internalId  === '17') {
      fileUploadModule.setUploadFile17(files[0]);
      fileUploadModule.setCodeNo17(this.value);
    }
    if (this.internalId  === '18') {
      fileUploadModule.setUploadFile18(files[0]);
      fileUploadModule.setCodeNo18(this.value);
    }
    if (this.internalId  === '19') {
      fileUploadModule.setUploadFile19(files[0]);
      fileUploadModule.setCodeNo19(this.value);
    }
    if (this.internalId  === '20') {
      fileUploadModule.setUploadFile20(files[0]);
      fileUploadModule.setCodeNo20(this.value);
    }
    //2022.02.16 jinno 添付ファイル追加対応 start
    if (this.internalId  === '21') {
      fileUploadModule.setUploadFile21(files[0]);
      fileUploadModule.setCodeNo21(this.value);
    }

    if (this.internalId  === '22') {
      fileUploadModule.setUploadFile22(files[0]);
      fileUploadModule.setCodeNo22(this.value);
    }

    if (this.internalId  === '23') {
      fileUploadModule.setUploadFile23(files[0]);
      fileUploadModule.setCodeNo23(this.value);
    }

    if (this.internalId  === '24') {
      fileUploadModule.setUploadFile24(files[0]);
      fileUploadModule.setCodeNo24(this.value);
    }

    if (this.internalId  === '25') {
      fileUploadModule.setUploadFile25(files[0]);
      fileUploadModule.setCodeNo25(this.value);
    }

    if (this.internalId  === '26') {
      fileUploadModule.setUploadFile26(files[0]);
      fileUploadModule.setCodeNo26(this.value);
    }

    if (this.internalId  === '27') {
      fileUploadModule.setUploadFile27(files[0]);
      fileUploadModule.setCodeNo27(this.value);
    }

    if (this.internalId  === '28') {
      fileUploadModule.setUploadFile28(files[0]);
      fileUploadModule.setCodeNo28(this.value);
    }

    if (this.internalId  === '29') {
      fileUploadModule.setUploadFile29(files[0]);
      fileUploadModule.setCodeNo29(this.value);
    }
    if (this.internalId  === '30') {
      fileUploadModule.setUploadFile30(files[0]);
      fileUploadModule.setCodeNo30(this.value);
    }
    //2022.02.16 jinno 添付ファイル追加対応 end
  }


  private created() {
    // ラベルの設定
    if (this.isgroup && this.label) {
      this.innerLabel = this.label;
    }
    // クリアボタンの設定
    this.clearable = !(this.readonly || this.disabled);
    if (this.invaildMessage) {
      this.privateInvaildMessage = this.invaildMessage;
    }
    // validationルールの設定
    this.rules = [
      // (value: any) => (this.isValidateRequiredFile(value)) || '必須項目です。',
      // (text: string) => (this.isValidateRequired(text)) || '必須項目です。',
      // (value: string) => (this.isValidate(value)) || this.privateInvaildMessage,
      ];
    // 文字数カウンタの設定
    if (this.maxlength) {
      this.counter = this.maxlength;
    }
  }

  // validationの設定
  // private isValidateRequired(value: string) {
  //   return this.validate.isValidateRequired(value, this.required);
  // }
  private isValidateRequiredFile(value: any) {
    if (this.internalId === '1') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile1, this.required);
    }
    if (this.internalId === '2') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile2, this.required);
    }
    if (this.internalId === '3') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile3, this.required);
    }
    if (this.internalId === '4') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile4, this.required);
    }
    if (this.internalId === '5') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile5, this.required);
    }
    if (this.internalId === '6') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile6, this.required);
    }
    if (this.internalId === '7') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile7, this.required);
    }
    if (this.internalId === '8') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile8, this.required);
    }
    if (this.internalId === '9') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile9, this.required);
    }
    if (this.internalId === '10') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile10, this.required);
    }
    if (this.internalId === '11') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile11, this.required);
    }
    if (this.internalId === '12') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile12, this.required);
    }
    if (this.internalId === '13') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile13, this.required);
    }
    if (this.internalId === '14') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile14, this.required);
    }
    if (this.internalId === '15') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile15, this.required);
    }
    if (this.internalId === '16') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile16, this.required);
    }
    if (this.internalId === '17') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile17, this.required);
    }
    if (this.internalId === '18') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile18, this.required);
    }
    if (this.internalId === '19') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile19, this.required);
    }
    if (this.internalId === '20') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile20, this.required);
    }
  // 2022.02.16 jinno 添付ファイル追加対応 start
    if (this.internalId === '21') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile21, this.required);
    }
    if (this.internalId === '22') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile22, this.required);
    }
    if (this.internalId === '23') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile23, this.required);
    }
    if (this.internalId === '24') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile24, this.required);
    }
    if (this.internalId === '25') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile25, this.required);
    }
    if (this.internalId === '26') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile26, this.required);
    }
    if (this.internalId === '27') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile27, this.required);
    }
    if (this.internalId === '28') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile28, this.required);
    }
    if (this.internalId === '29') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile29, this.required);
    }
    if (this.internalId === '30') {
      return this.validate.isValidateRequiredFile(fileUploadModule.uploadFile30, this.required);
    }
  // 2022.02.16 jinno 添付ファイル追加対応 end
  }
  // private isValidate(value: string) {
  //   return this.validate.isValidate(value, this.maxlength, this.minlength, this.pattern);
  // }
}
